module.exports = __webpack_public_path__ + "static/media/guide-tour-step-4.c71197ca.gif";